module.exports = __webpack_public_path__ + "static/media/Katarina.4d48a192.png";